import { FETCH_NI_SMELTERS_STATE } from '../../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_NI_SMELTERS_STATE:
			return action.payload;
		default:
			return state;
	}
};
